var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3618 0.651498C16.8441 0.133865 16.008 0.133865 15.4903 0.651498L9 7.12856L2.50967 0.638225C1.99204 0.120592 1.15586 0.120592 0.638225 0.638225C0.120592 1.15586 0.120592 1.99204 0.638225 2.50967L7.12856 9L0.638225 15.4903C0.120592 16.008 0.120592 16.8441 0.638225 17.3618C1.15586 17.8794 1.99204 17.8794 2.50967 17.3618L9 10.8714L15.4903 17.3618C16.008 17.8794 16.8441 17.8794 17.3618 17.3618C17.8794 16.8441 17.8794 16.008 17.3618 15.4903L10.8714 9L17.3618 2.50967C17.8661 2.00531 17.8661 1.15586 17.3618 0.651498Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuMobile);
export default __webpack_public_path__ + "static/media/close-menu-mobile.26b0f61ea0bf3358b2fc2d2fc829a58d.svg";
export { ForwardRef as ReactComponent };